export default (state, action) => {
  return Object.assign({}, state, {
    ...state,
    recently_viewed: [...action.recentlyViewed],
  });
};
